import Link from 'components/link'
import css from './social-embed-card.scss'

interface SocialEmbedCardProps {
  embedCode: string
  platform: string
  logoSrc?: string
  url: string
}
export const SocialEmbedCard = ({
  embedCode,
  platform,
  logoSrc,
  url,
}: SocialEmbedCardProps) => (
  <div className={css[`${platform}-social-embed-card`]}>
    <Link newWindow url={url}>
      <span
        className="social-embed-video"
        dangerouslySetInnerHTML={{ __html: embedCode }}
      />
      <img alt="logo" className="logo" src={logoSrc} />
    </Link>
  </div>
)
